<template>
  <div class="contents2">
    <img class="bg" :src="bgImg" />
    <div class="contents">
      <p class="text1">출장정비 (엔진오일, 배터리) <br v-if="isMobile" />1분만에 예약완료</p>
      <p class="text2">차종선택 → 정비상품선택 → <br v-if="isMobile" />날짜장소선택만 하면 끝!</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: 'static/img/main-content/contents2.png',
      isMobile: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.bgImg = 'static/img/main-content/contents2.png'
        this.isMobile = false
      } else {
        this.bgImg = 'static/img/mobile/main-content/contents2.png'
        this.isMobile = true
      }
    },
  },
}
</script>

<style scoped>
.contents2 {
  width: 100%;
  position: relative;
}
.contents2 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 28px;
    line-height: 36px;
    color: #000000;
    margin-bottom: 2%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 15px;
    color: #444444;
  }
}
@media (min-width: 1280px) {
  .text1 {
    font-style: normal;
    font-weight: 300;
    font-size: 2.2vw;
    line-height: 3vw;
    color: #000000;
    margin-bottom: 2%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 1.2vw;
    color: #444444;
  }
}
@media (min-width: 641px) {
  .contents2 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 5% 0 0 0;
    text-align: center;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents2 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    text-align: center;
  }
  .text1 {
    margin-top: 20%;

    font-style: normal;
    font-weight: 300;
    font-size: 6.4vw;
    line-height: 10vw;
    color: #000000;
    margin-bottom: 2%;
  }
  .text2 {
    font-style: normal;
    font-weight: 300;
    font-size: 4vw;
    line-height: 7vw;
    color: #444444;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/Contents2.vue